import { Link, Navigate } from 'react-router-dom';
import { COLUMNS } from '@bingo/shared';
import { useSession } from '../../lib/useSession.js';

/**
 * Página inicial.
 *
 * Duas portas, porque são dois aparelhos e duas pessoas diferentes: a TV, que
 * só exibe e não faz login, e o celular de quem conduz o jogo. Qualquer coisa
 * além disso aqui seria ruído — quem chega nesta tela ainda não sabe o que o
 * produto faz.
 */
export function Home() {
  const session = useSession();

  // Quem já entrou não precisa escolher de novo.
  if (session.signedIn) return <Navigate to="/inicio" replace />;

  return (
    <main className="auth">
      <section className="auth-card home">
        <div className="auth-stripe" aria-hidden="true">
          {COLUMNS.map((column) => (
            <i key={column.letter} style={{ background: column.color }} />
          ))}
        </div>

        <header className="auth-head">
          <p className="auth-brand" aria-hidden="true">
            {COLUMNS.map((column) => (
              <span key={column.letter} style={{ color: column.color }}>
                {column.letter}
              </span>
            ))}
          </p>
          <h1>Bingo</h1>
          <p className="auth-sub">Cante o bingo na TV e comande pelo celular.</p>
        </header>

        <div className="home-actions">
          <Link className="btn primary big block" to="/telao">
            📺 Jogar na TV
          </Link>
          <p className="hint-text">
            Abra isto na TV. Ela mostra um QR code para você conectar pelo celular.
          </p>

          <Link className="btn big block" to="/entrar">
            Entrar
          </Link>
          <p className="hint-text">Para operar o jogo, conferir cartelas e ver o histórico.</p>
        </div>
      </section>
    </main>
  );
}
